'use strict';
import * as $j_dev$002echeleb$002escalamigen$002e$002dForm$0024 from "./dev.cheleb.scalamigen.-Form$.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lsamples_ListElement$package$$anon$1$$anon$6() {
}
export { $c_Lsamples_ListElement$package$$anon$1$$anon$6 as $c_Lsamples_ListElement$package$$anon$1$$anon$6 };
$p = $c_Lsamples_ListElement$package$$anon$1$$anon$6.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lsamples_ListElement$package$$anon$1$$anon$6;
/** @constructor */
function $h_Lsamples_ListElement$package$$anon$1$$anon$6() {
}
export { $h_Lsamples_ListElement$package$$anon$1$$anon$6 as $h_Lsamples_ListElement$package$$anon$1$$anon$6 };
$h_Lsamples_ListElement$package$$anon$1$$anon$6.prototype = $p;
$p.b = (function() {
  return "<function0>";
});
$p.h = (function() {
  return $j_dev$002echeleb$002escalamigen$002e$002dForm$0024.$m_Ldev_cheleb_scalamigen_Form$().eU();
});
var $d_Lsamples_ListElement$package$$anon$1$$anon$6 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lsamples_ListElement$package$$anon$1$$anon$6, "samples.ListElement$package$$anon$1$$anon$6", ({
  pk: 1,
  d: 1,
  a: 1,
  f: 1
}));
export { $d_Lsamples_ListElement$package$$anon$1$$anon$6 as $d_Lsamples_ListElement$package$$anon$1$$anon$6 };
